/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type V1ApiKeysCreateKeyResponseData = {
  /**
   * Identifier used to manage the API key.
   */
  keyId: string;
  /**
   * API key secret, returned only once. Store it securely.
   */
  key: string;
};

/** @internal */
export const V1ApiKeysCreateKeyResponseData$inboundSchema: z.ZodType<
  V1ApiKeysCreateKeyResponseData,
  z.ZodTypeDef,
  unknown
> = z.object({
  keyId: z.string(),
  key: z.string(),
});

export function v1ApiKeysCreateKeyResponseDataFromJSON(
  jsonString: string,
): SafeParseResult<V1ApiKeysCreateKeyResponseData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => V1ApiKeysCreateKeyResponseData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1ApiKeysCreateKeyResponseData' from JSON`,
  );
}
